export default "__VITE_ASSET__a92646a2__"